export default __webpack_public_path__ + "static/media/jeff_dwoskin.0c81d8af.png";